import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetClientsQuery, useMoveLibraryMutation } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './MoveLibraryDialog.module.css';

type MoveLibraryDialogProps = {
    onClose: () => void,
    libraryId: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const MoveLibraryDialog = (props: MoveLibraryDialogProps) => {
    const { libraryId, style, visible, onClose } = props;
    const [moveLibrary, moveLibraryResult] = useMoveLibraryMutation();
    const [searchClients, setSearchClients] = useState('');
    const [validationError, setValidationError] = useState('');

    const clients = useGetClientsQuery({
        variables: { contains: searchClients }
    });

    const handleSubmit = () => {
        const selectedClient = clients.data?.ClientList?.nodes?.filter(c => c?.name === searchClients)[0];
        if (!searchClients) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selectedClient) {
            setValidationError('Please Select A Valid Client!');
            return;
        }
        setValidationError('');
        moveLibrary({
            variables: { id: libraryId, clientId: selectedClient?.id }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="Move Library"
            type="OkCancel"
            isLoading={moveLibraryResult.loading}
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.MoveLibraryDialog}
            style={style}
            data-testid="MoveLibraryDialog">
            <FormAutoComplete
                label="Client"
                name="client"
                value={searchClients}
                onChange={setSearchClients}
                options={(clients.data?.ClientList?.nodes?.map(c => c?.name) || []).filter((n): n is string => !!n)}
            />
        </DialogBase>
    );
};

export default MoveLibraryDialog;